// Filter options for dropdowns
export const filterOptions = {
    portfolios: [
        { value: "portfolio_a", label: "Portfolio A" },
        { value: "portfolio_b", label: "Portfolio B" },
        { value: "portfolio_c", label: "Portfolio C" },
    ],
    trackingStatuses: [
        { value: "Complete", label: "Complete" },
        { value: "In Transit", label: "In Transit" },
        { value: "Picked Up", label: "Picked Up" },
        { value: "Booked", label: "Booked" },
        { value: "Delivered", label: "Delivered" },
        { value: "Exception", label: "Exception" },
    ],
    toStates: [
        { value: "VIC", label: "VIC" },
        { value: "NSW", label: "NSW" },
        { value: "QLD", label: "QLD" },
        { value: "SA", label: "SA" },
        { value: "WA", label: "WA" },
        { value: "TAS", label: "TAS" },
        { value: "NT", label: "NT" },
        { value: "ACT", label: "ACT" },
    ],
    yesNo: [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
    ],
    reasons: [
        { value: "", label: "-" },
        { value: "late_pickup", label: "Late Pickup" },
        { value: "late_delivery", label: "Late Delivery" },
        { value: "incorrect_address", label: "Incorrect Address" },
        { value: "customer_not_available", label: "Customer Not Available" },
        { value: "weather_delay", label: "Weather Delay" },
        { value: "vehicle_breakdown", label: "Vehicle Breakdown" },
        { value: "carrier_delay", label: "Carrier Delay" },
        { value: "other", label: "Other" },
    ],
    serviceFlags: [
        { value: "dangerous_goods", label: "Dangerous Goods (DG)" },
        { value: "requires_booking", label: "Requires Booking" },
        { value: "requires_tailgate", label: "Requires Tailgate" },
        { value: "rural_delivery", label: "Rural Delivery" },
        { value: "hand_unloading", label: "Hand Unloading" },
        { value: "tail_lift", label: "Tail Lift" },
    ],
};

// Scan event types with their color mappings
export const scanEventColors = {
    Booked: {
        bg: "bg-orange-100",
        text: "text-orange-700",
        dot: "bg-orange-500",
    },
    BOOKED: {
        bg: "bg-orange-100",
        text: "text-orange-700",
        dot: "bg-orange-500",
    },
    Manifested: {
        bg: "bg-gray-100",
        text: "text-gray-700",
        dot: "bg-gray-400",
    },
    Unmanifested: {
        bg: "bg-gray-100",
        text: "text-gray-600",
        dot: "bg-gray-400",
    },
    ALLOCATED: { bg: "bg-blue-100", text: "text-blue-700", dot: "bg-blue-400" },
    "PICKED UP": { bg: "bg-sky-100", text: "text-sky-700", dot: "bg-sky-500" },
    PickupArrive: { bg: "bg-sky-100", text: "text-sky-700", dot: "bg-sky-500" },
    PickupComplete: {
        bg: "bg-sky-100",
        text: "text-sky-700",
        dot: "bg-sky-500",
    },
    DepartPickup: {
        bg: "bg-indigo-100",
        text: "text-indigo-700",
        dot: "bg-indigo-500",
    },
    "In Transit": {
        bg: "bg-blue-100",
        text: "text-blue-700",
        dot: "bg-blue-500",
    },
    DeliveryArrive: {
        bg: "bg-teal-100",
        text: "text-teal-700",
        dot: "bg-teal-500",
    },
    "At Delivery": {
        bg: "bg-teal-100",
        text: "text-teal-700",
        dot: "bg-teal-500",
    },
    "At Pickup": { bg: "bg-sky-100", text: "text-sky-700", dot: "bg-sky-500" },
    "On For Delivery": {
        bg: "bg-cyan-100",
        text: "text-cyan-700",
        dot: "bg-cyan-500",
    },
    "Sorted for Delivery": {
        bg: "bg-violet-100",
        text: "text-violet-700",
        dot: "bg-violet-500",
    },
    REDELIVERY: {
        bg: "bg-amber-100",
        text: "text-amber-700",
        dot: "bg-amber-500",
    },
    Complete: {
        bg: "bg-emerald-100",
        text: "text-emerald-700",
        dot: "bg-emerald-500",
    },
    DeliveryComplete: {
        bg: "bg-emerald-100",
        text: "text-emerald-700",
        dot: "bg-emerald-500",
    },
    POD: { bg: "bg-green-100", text: "text-green-700", dot: "bg-green-500" },
    "POD Received": {
        bg: "bg-green-100",
        text: "text-green-700",
        dot: "bg-green-500",
    },
};

const defaultScanColor = {
    bg: "bg-gray-100",
    text: "text-gray-700",
    dot: "bg-gray-400",
};

export const getScanEventColor = (eventType) => {
    for (const [key, colors] of Object.entries(scanEventColors)) {
        if (eventType.includes(key)) return colors;
    }
    return defaultScanColor;
};